export default {
    authData:Object,playerData:Object
};